import { getCompany, getUserId } from '../_utils/storage_handler';
import { sendFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/remission';

export const findRemission = async () => {
    return await sendFetch(`${BASE_PATH}/all`, GET_OPTIONS);
}

export const remissionPDF = async (body) => {
    return await sendFetch(`${BASE_PATH}/remission-pdf`, POST_OPTIONS, body);
}

export const findRemissionsFact = async () => {
    return await sendFetch(`${BASE_PATH}/remissions-fact`, GET_OPTIONS);
}

export const findAllRemissionsOrderByDate = async () => {
    return await sendFetch(`${BASE_PATH}/all/order/date`, GET_OPTIONS);
}

export const remissionPDFByUuid = async (uuid) => {
    return await sendFetch(`${BASE_PATH}/remission-pdf/uuid/${uuid}`, GET_OPTIONS);
}

export const remissionExcelByMonthYear = async (month, year) => {
    return await sendFetch(`${BASE_PATH}/remission-excel/month/year/${month}/${year}`, GET_OPTIONS);
}
